import { render, staticRenderFns } from "./commentEdit.vue?vue&type=template&id=6805b39e&scoped=true&"
import script from "./commentEdit.vue?vue&type=script&lang=js&"
export * from "./commentEdit.vue?vue&type=script&lang=js&"
import style0 from "./commentEdit.vue?vue&type=style&index=0&id=6805b39e&lang=stylus&scoped=true&"
import style1 from "./commentEdit.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805b39e",
  null
  
)

export default component.exports